import { api } from './index';

export interface MenuItem {
  id: string;
  name: string;
  code: string;
  route: string;
  icon?: string;
  menuOrder: number;
  description?: string;
  children?: MenuItem[];
}

export interface MenuResponse {
  userId: string;
  menu: MenuItem[];
}

export const menuApi = {
  // Get user menu based on permissions
  getUserMenu: async (): Promise<MenuResponse> => {
    const response = await api.get('/menu/user-menu');
    return response.data;
  },

  // Get mobile menu for mobile app
  getMobileMenu: async (): Promise<MenuResponse> => {
    const response = await api.get('/menu/mobile-menu');
    return response.data;
  },

  // Check if user has permission for a specific function and action
  checkPermission: async (functionCode: string, action: string): Promise<boolean> => {
    try {
      const response = await api.get(`/permission-groups/check-permission/${functionCode}/${action}`);
      return response.data.hasPermission;
    } catch (error) {
      console.error('Error checking permission:', error);
      return false;
    }
  },

  // Check if user has access to a specific function
  checkFunctionAccess: async (functionCode: string): Promise<boolean> => {
    try {
      const response = await api.get(`/permission-groups/check-function-access/${functionCode}`);
      return response.data.hasAccess;
    } catch (error) {
      console.error('Error checking function access:', error);
      return false;
    }
  },

  // Get user's permissions for all functions
  getUserPermissions: async () => {
    const response = await api.get('/permission-groups/user-permissions');
    return response.data;
  },

  // Get mobile accessible functions
  getMobileAccessibleFunctions: async () => {
    const response = await api.get('/permission-groups/mobile-accessible-functions');
    return response.data;
  },
}; 